import React from "react";

import { Admin, Resource } from "admin-on-rest";
import boxRestClient from "./restClient";
import authClient from "./authClient";

import {
  CompaniesList,
  CreateCompany,
  EditCompany,
  DeleteCompany
} from "./pages/companies/companies";
import { Init } from "./pages/companies/init_page";
import { Init_sxolia } from "./pages/init_page_sxolia";
import {
  SubCompaniesList,
  CreateSubCompany,
  EditSubCompany,
  DeleteSubCompany
} from "./pages/companies/sub_companies";
import {
  ProductsList,
  CreateProduct,
  EditProduct,
  DeleteProduct
} from "./pages/companies/products";
import {
  OximataList,
  CreateOximata,
  EditOximata,
  DeleteOximata
} from "./pages/companies/oximatas";

import { AdminList, CreateAdmin, EditAdmin, DeleteAdmin } from "./pages/admins";
import {
  ComplaintsList,
  EditComplaint,
  DeleteComplaint
} from "./pages/complaints";
import { UserList, CreateUser, EditUser, DeleteUser } from "./pages/users";
import {
  NewsList,
  CreateNew,
  EditNew,
  DeleteNew
} from "./pages/companies/news";
import {
  QuestionList,
  CreateQuestion,
  EditQuestion,
  DeleteQuestion
} from "./pages/questions";
import { AnswerList, AnswerShow } from "./pages/answer";
import {
  SurveysList,
  CreateSurvey,
  EditSurvey,
  DeleteSurvey,
  showSurvey
} from "./pages/surveys";

import AdminIcon from "material-ui/svg-icons/social/people";
import UserIcon from "material-ui/svg-icons/social/person";
import CompanyIcon from "material-ui/svg-icons/action/home";
import BranchIcon from "material-ui/svg-icons/action/extension";
import DeshcriptionIcon from "material-ui/svg-icons/action/description";
import PagesIcon from "material-ui/svg-icons/social/pages";
import QuestionIcon from "material-ui/svg-icons/action/assessment";
import OximataIcon from "material-ui/svg-icons/maps/local-taxi";
import ProductIcon from "material-ui/svg-icons/action/card-membership";
import dashboardIcon from "material-ui/svg-icons/action/dashboard";
import Menu from "./Menu";
import "./App.css";
import Dashboard from "./Dashboard";
import greekMessages from "./translate/greekMessages";
import englishMessages from "./translate/englishMessages";
import customReducer from "./customReducer";

var Config = require("./config");

const messages = {
  el: greekMessages,
  en: englishMessages,
};

const App = () => (
  <Admin
    customReducers={{ customReducer }}
    dashboard={Dashboard}
    authClient={authClient}
    restClient={boxRestClient(Config.serverUrl + "/api")}
    title="Driveyes Admin Panel"
    locale="en"
    menu={Menu}
    messages={messages}
  >
    <Resource
      title="Διαχειριστες"
      name="admins"
      list={AdminList}
      create={CreateAdmin}
      edit={EditAdmin}
      remove={DeleteAdmin}
      icon={AdminIcon}
    />

    <Resource
      name="users"
      list={UserList}
      create={CreateUser}
      edit={EditUser}
      remove={DeleteUser}
      icon={UserIcon}
    />

    <Resource
      name="companies"
      list={CompaniesList}
      create={CreateCompany}
      edit={EditCompany}
      remove={DeleteCompany}
      icon={CompanyIcon}
    />

    <Resource
      name="branches"
      list={SubCompaniesList}
      create={CreateSubCompany}
      edit={EditSubCompany}
      remove={DeleteSubCompany}
      icon={BranchIcon}
    />

    <Resource
      name="oximata"
      list={OximataList}
      create={CreateOximata}
      edit={EditOximata}
      remove={DeleteOximata}
      icon={OximataIcon}
    />

    <Resource name="company_init" list={Init} icon={dashboardIcon} />

    <Resource
      name="product"
      list={ProductsList}
      create={CreateProduct}
      edit={EditProduct}
      remove={DeleteProduct}
      icon={ProductIcon}
    />

    <Resource
      name="survey"
      list={SurveysList}
      create={CreateSurvey}
      edit={EditSurvey}
      show={showSurvey}
      remove={DeleteSurvey}
      icon={QuestionIcon}
    />

    <Resource
      name="questions"
      list={QuestionList}
      create={CreateQuestion}
      edit={EditQuestion}
      remove={DeleteQuestion}
      icon={DeshcriptionIcon}
    />

    <Resource
      name="news"
      list={NewsList}
      create={CreateNew}
      edit={EditNew}
      remove={DeleteNew}
    />

    <Resource name="sxolia_init" list={Init_sxolia} icon={dashboardIcon} />

    <Resource
      name="complaint"
      list={ComplaintsList}
      edit={EditComplaint}
      remove={DeleteComplaint}
      icon={PagesIcon}
    />

    <Resource
      name="answers"
      list={AnswerList}
      show={AnswerShow}
      icon={QuestionIcon}
    />
  </Admin>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js